import { Text } from 'iq-blueberry'

import './style.styl'

const RequiredFieldsDisclaimer = () => (
  <div className="required-fields-disclaimer">
    <Text as="p" defaultColor="common" variant="body-small">
      <span>*</span> Indica que o campo é obrigatório
    </Text>
  </div>
)

export default RequiredFieldsDisclaimer
